module.exports = __webpack_public_path__ + "85b7f3cd7a10536b909621a6c8f13748.png";